<template>
    <app-layout title="User Management">
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                    Quote Block Types
                </h2>
                <div class="flex">
                    <a @click.prevent="importAllFromDisk" :href="null"
                       class="cursor-pointer mr-2 max-w-min whitespace-nowrap flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red">
                        Import all quote blocks from disk
                        <span class="ml-2" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                            </svg>
                        </span>
                    </a>
                    <a @click.prevent="updateAllBlockContent" :href="null"
                                  class="cursor-pointer mr-2 max-w-min whitespace-nowrap flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red">
                        Update blocks' content from disk
                        <span class="ml-2" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                        </span>
                    </a>
                    <inertia-link :href="route('admin.quote-block-type.create')" class="max-w-min whitespace-nowrap flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red">
                        Create quote block type
                        <span class="ml-2" aria-hidden="true">+</span>
                    </inertia-link>
                </div>
            </div>
        </template>
        <div class="w-full overflow-hidden rounded-lg shadow">
            <table-layout>
                <template v-slot:theadRow>
                    <th class="px-4 py-3">Name</th>
                    <th class="px-4 py-3">Source folder name</th>
                    <th class="px-4 py-3">Preview</th>
                    <th class="px-4 py-3">Content last updated</th>
                    <th class="px-4 py-3 text-right">Actions</th>
                </template>
                <template v-slot:tbody>
                    <tr v-for="quoteBlockType in paginatedQuoteBlockTypes.data" class="text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    <p class="font-semibold">{{ quoteBlockType.name }}</p>
<!--                                    <p class="text-xs text-gray-600 dark:text-gray-400">-->
<!--                                        10x Developer-->
<!--                                    </p>-->
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm">
                            {{ quoteBlockType.source_folder_name }}
                        </td>
                        <td class="px-4 py-3 text-sm">
                            <img alt="block type preview" class="block-type-preview" :src="quoteBlockType.preview_image_url"/>

                        </td>
                        <td class="px-4 py-3 text-sm">
                            {{ quoteBlockType.content_updated_at ? dayjs(quoteBlockType.content_updated_at).format("DD-MM-YYYY HH:mm") : 'never'}}
                        </td>
                        <td class="px-4 py-3 text-right">
                            <div class="flex items-center justify-end space-x-1 text-sm">
                                <inertia-link :href="route('admin.quote-block-type.edit', quoteBlockType.id)" class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        aria-label="Edit"
                                >
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                                    </svg>
                                </inertia-link>
                                <a :href="null" @click.prevent="updateBlockContent(quoteBlockType)"
                                   class="cursor-pointer flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                   aria-label="Manage Projects"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </a>
                                <button @click.prevent="deleteQuoteBlockType(quoteBlockType)" class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        aria-label="Delete"
                                >
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                </template>
            </table-layout>
            <table-pagination :pagination-object="paginatedQuoteBlockTypes"/>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import TablePagination from "@/Jetstream/TablePagination";
import TableLayout from "@/Jetstream/TableLayout";
import Pill from "@/Jetstream/Pill";
import { Inertia } from '@inertiajs/inertia'
import {inject} from "vue";
import dayjs from "dayjs";

export default defineComponent({
    methods: {dayjs},
    components: {
        Pill,
        TableLayout,
        TablePagination,
        AppLayout
    },
    props: {
        paginatedQuoteBlockTypes: Object,
    },
    data() {
        return {
            title: "Test"
        }
    },
    setup() {
        const $swal = inject('$swal');
        const deleteQuoteBlockType = (block) => {
            $swal({
                title: 'Are you sure you want to delete this quote block type?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.delete(route('admin.quote-block-type.destroy', block.id));
                }
            });
        };
        const updateAllBlockContent = () => {
            Inertia.put(route('admin.quote-block-type.content.update-all'));
        }
        const updateBlockContent = (quoteBlockType) => {
            Inertia.put(route('admin.quote-block-type.content.update', {quoteBlockType: quoteBlockType.id}));
        }

        const importAllFromDisk = () => {
            Inertia.post(route('admin.quote-block-type.import'));
        }

        return {
            deleteQuoteBlockType,
            updateAllBlockContent,
            updateBlockContent,
            importAllFromDisk,
        };
    }
})
</script>

<style scoped>
.block-type-preview {
    max-width: 100px;
    max-height: 100px;
    width: auto;
    height: auto;
}
</style>
